import React from 'react';
import styled from 'styled-components';

import { OptionType } from '@/typings/common';

import { StockFilterRangeSelectProps } from './StockFilterRangeSelect.types';
import MaxRangeSelect from './components/Ranges/MaxRangeSelect';
import MinRangeSelect from './components/Ranges/MinRangeSelect';

function StockFilterRangeSelect({
  label,
  options,
  values,
  onChange,
  onClear,
}: StockFilterRangeSelectProps) {
  function onChangeMinRange(value: OptionType) {
    if (onChange) {
      onChange({ min: value, max: values.max });
    }
  }

  function onChangeMaxRange(value: OptionType) {
    if (onChange) {
      onChange({ min: values.min, max: value });
    }
  }

  return (
    <Component>
      {label && <Label>{label}</Label>}

      <Selects>
        <MinRangeSelect
          values={values}
          options={options}
          onChange={onChangeMinRange}
          onClear={onClear}
        />
        <MaxRangeSelect
          values={values}
          options={options}
          onChange={onChangeMaxRange}
          onClear={onClear}
        />
      </Selects>
    </Component>
  );
}

export default StockFilterRangeSelect;

const Component = styled.div`
  position: relative;
  width: 100%;
`;

const Label = styled.p`
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
  color: ${(props) => props.theme.blue100};
`;

const Selects = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-start;
`;
